import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react'
import toast from 'react-hot-toast'

// Define props for the toast
interface ToastProps {
  t: any // Toast object from react-hot-toast
  type: 'success' | 'error' | 'warning' | 'info'
  title: string
  message: string
}

// Map types to icons and colors - using Tailtations brand colors
const toastConfig = {
  success: { Icon: CheckCircle, color: 'text-[#8a3134]', bg: 'bg-white', border: 'border-[#8a3134]' },
  error: { Icon: XCircle, color: 'text-[#962831]', bg: 'bg-white', border: 'border-[#962831]' },
  warning: { Icon: AlertTriangle, color: 'text-[#d4af37]', bg: 'bg-white', border: 'border-[#d4af37]' },
  info: { Icon: Info, color: 'text-blue-500', bg: 'bg-white', border: 'border-gray-300' },
}

export const EnterpriseToast = ({ t, type, title, message }: ToastProps) => {
  const { Icon, color, bg, border } = toastConfig[type]

  return (
    <div
      className={`${
        t.visible ? 'animate-enter' : 'animate-leave'
      } pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg ${bg} shadow-lg ring-1 ring-black ring-opacity-5 border ${border}`}
    >
      <div className="p-3">
        <div className="flex items-start gap-3">
          {/* Icon - 20x20px, flex-shrink-0 */}
          <div className="flex-shrink-0">
            <Icon className={`h-5 w-5 ${color}`} aria-hidden="true" />
          </div>

          {/* Content - flexible width */}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-900 leading-tight">{title}</p>
            {message && <p className="mt-1 text-xs text-gray-600 leading-tight">{message}</p>}
          </div>

          {/* Close Button - 16x16px icon */}
          <div className="flex-shrink-0">
            <button
              type="button"
              className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-[#8a3134] focus:ring-offset-2 transition-colors"
              onClick={() => toast.dismiss(t.id)}
              aria-label="Close notification"
            >
              <X className="h-4 w-4" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
